import { useMemo } from "react";

export const useIsIOSWebkit = () => {
  return useMemo(() => {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    return iOS && webkit;
  }, []);
};
